<div class="p-3">
    <div class="theme-container"> 
        <!-- <div class="py-4">
            <div fxLayout="column" fxLayoutAlign="center center" class="text-center">  
                <h1 class="secondary-font">Comment proposer son véhicule sur Location Auto Senegal ?</h1>             
                <p>Cliquez sur une question pour développer et révéler la réponse.</p>
            </div>
            <mat-accordion multi="true">              
                <mat-expansion-panel *ngFor="let faq of faqs; let i = index;" [expanded]="i === 0">
                    <mat-expansion-panel-header>
                        <mat-panel-title fxLayout="row" fxLayoutAlign="space-between">
                            <div class="fw-500">{{faq.question}}</div>
                            <div fxShow="false" fxShow.gt-sm="true" class="text-muted">
                                {{faq.status}}  
                            </div>
                        </mat-panel-title>               
                    </mat-expansion-panel-header>          
                    <p>{{faq.answer}} </p>
                    <div class="divider"></div>
                    <p class="mt-2 mb-0"><small class="text-muted">Cette réponse vous a-t-elle été utile ?<button mat-button>Oui</button><button mat-button>Non</button></small></p>
                </mat-expansion-panel>
            </mat-accordion>
        </div>   -->
        <!--  -->
        <div class="py-4">
            <div fxLayout="column" fxLayoutAlign="center center" class="text-center">  
                <h1 class="secondary-font">Questions Fréquemment Posées</h1>             
                <p>Cliquez sur une question pour développer et révéler la réponse.</p>
            </div>
            <mat-accordion multi="true">              
                <mat-expansion-panel *ngFor="let faq of faqs_2; let i = index;" [expanded]="i === 0">
                    <mat-expansion-panel-header>
                        <mat-panel-title fxLayout="row" fxLayoutAlign="space-between">
                            <div class="fw-500">{{faq.question}}</div>
                            <div fxShow="false" fxShow.gt-sm="true" class="text-muted">
                                {{faq.status}}  
                            </div>
                        </mat-panel-title>               
                    </mat-expansion-panel-header>          
                    <p>{{faq.answer}} </p>
                    <div class="divider"></div>
                    <p class="mt-2 mb-0"><small class="text-muted">Cette réponse vous a-t-elle été utile ? <button mat-button>Oui</button><button mat-button>Non</button></small></p>
                </mat-expansion-panel>
            </mat-accordion>
        </div> 
    </div>
</div>

<!-- <app-get-in-touch></app-get-in-touch> -->
